"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKpoMatrix = getKpoMatrix;
exports.firstEightRowsHeader = firstEightRowsHeader;
exports.addMatrixHeaders = addMatrixHeaders;
exports.insertNoDataMessage = insertNoDataMessage;
exports.insertMatrixData = insertMatrixData;
var headers_1 = require("../headers");
var kpo_card_1 = require("./kpo_card");
var keo_card_1 = require("../keo/keo_card");
var common_1 = require("../common");
// Nagłówki
var headers = headers_1.KPO_CONFIRMED_HEADERS;
var sheetHeaders = headers_1.SHEET_EIGHT_HEADERS;
/**
 * Pobiera macierz danych KPO
 * @param EupType - dane wybranego EUP
 * @param DateFrom - Data początkowa
 * @param DateTo - Data końcowa
 * @returns Macierz danych KPO
 */
function getKpoMatrix(EupType, DateFrom, DateTo) {
    return __awaiter(this, void 0, void 0, function () {
        var kpoList, reportKpoData, keoList, _i, keoList_1, keoCard, limitedReportKpoData, matrix;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, kpo_card_1.getKpoDataAndMappingToList)(EupType, DateFrom, DateTo)];
                case 1:
                    kpoList = _a.sent();
                    reportKpoData = kpoList.map(function (item) { return ({
                        cardNumber: item.cardNumber || "",
                        wasteCode: item.wasteCode || "",
                        wasteCodeAndDescription: (0, common_1.extractWasteDescription)(item.wasteCodeAndDescription) || "",
                        isDangerous: (0, common_1.isDangerousWaste)(item.wasteCode) || false,
                        correctedWasteMass: item.correctedWasteMass !== undefined && item.correctedWasteMass !== null
                            ? Number(item.correctedWasteMass).toFixed(3)
                            : "",
                        realTransportDate: item.realTransportDate ? (0, common_1.convertToExcelDate)(item.realTransportDate) : "",
                        vehicleRegNumber: item.vehicleRegNumber || "",
                        receiveConfirmationDate: item.receiveConfirmationDate ? (0, common_1.convertToExcelDate)(item.receiveConfirmationDate) : "",
                        receiverNameOrFirstNameAndLastName: item.receiverNameOrFirstNameAndLastName || "",
                        receiverEupAddress: item.receiverEupAddress || "", // item.receiverAddress || "",
                        cardStatus: item.cardStatus || "",
                        kpoLastModifiedAt: item.kpoLastModifiedAt ? (0, common_1.convertToExcelDate)(item.kpoLastModifiedAt) : "",
                        carrierNameOrFirstNameAndLastName: item.carrierNameOrFirstNameAndLastName || "",
                        carrierAddress: item.carrierAddress || "",
                        keoCardNumber: "brak",
                        keoCount: "brak"
                    }); });
                    return [4 /*yield*/, (0, keo_card_1.getKeoDataAndMappingOnlyForwardedToList)(EupType.clientId, EupType.clientSecret, EupType.eupId, DateFrom.getFullYear())];
                case 2:
                    keoList = _a.sent();
                    _i = 0, keoList_1 = keoList;
                    _a.label = 3;
                case 3:
                    if (!(_i < keoList_1.length)) return [3 /*break*/, 6];
                    keoCard = keoList_1[_i];
                    return [4 /*yield*/, (0, keo_card_1.fetchKeoForwardedDetails)(EupType.clientId, EupType.clientSecret, EupType.eupId, keoCard)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    _i++;
                    return [3 /*break*/, 3];
                case 6:
                    //Sprawdź czy istnieje karta KEO dla danego kodu odpadu, a następnie sprawdź powiązania w Forwarded
                    reportKpoData.forEach(function (item) {
                        // Najpierw sprawdź czy istnieje karta KEO dla tego kodu odpadu
                        var keoForWasteCode = keoList.find(function (keo) { return keo.wasteCode === item.wasteCode; });
                        if (!keoForWasteCode) {
                            // Jeśli nie ma karty KEO dla tego kodu odpadu
                            item.keoCardNumber = "brak karty KEO";
                        }
                        else {
                            // Jeśli istnieje karta KEO dla kodu odpadu, sprawdź czy KPO jest w sekcji Forwarded
                            var keoItem = keoList.find(function (keo) { var _a, _b; return (_b = (_a = keo.Forwarded) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.some(function (i) { return i.cardNumberKpo === item.cardNumber; }); });
                            if (keoItem) {
                                item.keoCardNumber = keoItem.cardNumber;
                            }
                            else {
                                item.keoCardNumber = "Nie";
                            }
                        }
                    });
                    //Sprawdz ile razy w element w keoList.Forwarded?.Item? wystepuje item.cardNumberKpo 
                    reportKpoData.forEach(function (item) {
                        var count = keoList.reduce(function (acc, keo) {
                            var _a, _b;
                            return acc + (((_b = (_a = keo.Forwarded) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.filter(function (i) { return i.cardNumberKpo === item.cardNumber; }).length) || 0);
                        }, 0);
                        // "brak wpisu w KEO" gdy count = 0
                        if (item.keoCardNumber === "Nie" || item.keoCardNumber === "brak karty KEO") {
                            item.keoCount = "brak wpisu w KEO";
                            return;
                        }
                        item.keoCount = count > 1 ? "Tak (".concat((count - 1).toString(), ")") : "Nie";
                    });
                    limitedReportKpoData = (0, common_1.limitTrialData)(reportKpoData, EupType === null || EupType === void 0 ? void 0 : EupType.isTrial);
                    matrix = __spreadArray([
                        headers
                    ], limitedReportKpoData.map(function (item) { return [
                        item.cardNumber || "",
                        item.wasteCode || "",
                        item.wasteCodeAndDescription || "",
                        item.isDangerous ? "Tak" : "Nie",
                        item.correctedWasteMass !== undefined && item.correctedWasteMass !== null
                            ? parseFloat(Number(item.correctedWasteMass).toFixed(4)).toString()
                            : "",
                        item.cardStatus || "",
                        item.kpoLastModifiedAt || "",
                        item.realTransportDate || "",
                        item.vehicleRegNumber || "",
                        item.carrierNameOrFirstNameAndLastName || "",
                        item.carrierAddress || "",
                        item.receiveConfirmationDate || "",
                        item.receiverNameOrFirstNameAndLastName || "",
                        item.receiverEupAddress || "",
                        item.keoCardNumber || "brak",
                        item.keoCount || "brak"
                    ]; }), true);
                    return [2 /*return*/, matrix];
            }
        });
    });
}
/**
 * Metoda tworzy nagłówek arkusza - pierwsze 8 wierszy oraz formaruje szerokości kolum dla danych
 * @param sheet - arkusz do wstawienia nagłówka
 * @param context - kontekst Excel
 * @param eupType - dane wybranego EUP
 * @param dateFrom - data początkowa
 * @param dateTo - data końcowa
 */
function firstEightRowsHeader(sheetName, eupType, dateFrom, dateTo) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, ReportId, headerTitleRange, headerValueRange, currentdate, formattedDate;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    // Ustawienie koloru tła dla całego arkusza
                                    sheet.getRange("A1:P8").format.fill.color = "#E7E7E7";
                                    ReportId = "CW02";
                                    // Wysokości pierwszych 8 wierszy
                                    sheet.getRange("1:1").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("2:2").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("3:3").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("4:4").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("5:5").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("6:6").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("7:7").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("8:8").format.rowHeight = common_1.firstSevenRowsLastRowHeight;
                                    // Formatowanie kolumn
                                    sheet.getRange("A:A").format.columnWidth = 255;
                                    sheet.getRange("B:B").format.columnWidth = 115;
                                    sheet.getRange("C:C").format.columnWidth = 365;
                                    sheet.getRange("D:D").format.columnWidth = 155;
                                    sheet.getRange("E:E").format.columnWidth = 135;
                                    sheet.getRange("F:F").format.columnWidth = 205;
                                    sheet.getRange("G:G").format.columnWidth = 155;
                                    sheet.getRange("H:H").format.columnWidth = 155;
                                    sheet.getRange("I:I").format.columnWidth = 105;
                                    sheet.getRange("J:J").format.columnWidth = 205;
                                    sheet.getRange("K:K").format.columnWidth = 205;
                                    sheet.getRange("L:L").format.columnWidth = 155;
                                    sheet.getRange("M:M").format.columnWidth = 205;
                                    sheet.getRange("N:N").format.columnWidth = 205;
                                    sheet.getRange("O:O").format.columnWidth = 205;
                                    sheet.getRange("P:P").format.columnWidth = 170;
                                    headerTitleRange = sheet.getRange("A1:A7");
                                    headerTitleRange.format.fill.color = "#688BBB";
                                    headerTitleRange.format.font.bold = true;
                                    headerTitleRange.format.font.color = "#FFFFFF";
                                    headerTitleRange.format.font.size = common_1.firstSevenRowsFontSize;
                                    headerTitleRange.format.verticalAlignment = "Center";
                                    sheet.getRange("A1").values = [[sheetHeaders.REPORT_TITLE]];
                                    sheet.getRange("A1").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A1").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A2").values = [[sheetHeaders.DESCRIPTION]];
                                    sheet.getRange("A2").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A2").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A3").values = [[sheetHeaders.BDOENTITY]];
                                    sheet.getRange("A3").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A3").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A4").values = [[sheetHeaders.MPD]];
                                    sheet.getRange("A4").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A4").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A5").values = [[sheetHeaders.MPD_NUMBER]];
                                    sheet.getRange("A5").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A5").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A6").values = [[sheetHeaders.REPORT_PERIOD]];
                                    sheet.getRange("A6").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A6").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A7").values = [[sheetHeaders.DATA_IMPORT]];
                                    sheet.getRange("A7").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A7").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    headerValueRange = sheet.getRange("B1:C7");
                                    headerValueRange.format.fill.color = "#F7F7F7";
                                    headerValueRange.format.font.color = "#000000";
                                    headerValueRange.format.font.size = common_1.firstSevenRowsFontSize;
                                    headerValueRange.format.font.bold = false;
                                    headerValueRange.format.verticalAlignment = "Center";
                                    sheet.getRange("B1").values = [["".concat(ReportId, " - POTWIERDZONE KPO")]];
                                    sheet.getRange("B1").format.font.bold = true;
                                    sheet.getRange("B1").format.font.color = "#688BBB";
                                    sheet.getRange("B1:C1").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B1:C1").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("B2").values = [["Szczegółowe zestawienie kart przekazania odpadów ze statusem potwierdzenia przejęcia i potwierdzenia transportu wraz z weryfikacją wpisu do kart ewidencji odpadu"]];
                                    sheet.getRange("B2:C2").merge();
                                    sheet.getRange("B2:C2").format.wrapText = true;
                                    sheet.getRange("B2:C2").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B2:C2").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("B3").values = [[eupType.bdoentityname || "Brak danych"]];
                                    sheet.getRange("B3:C3").merge();
                                    sheet.getRange("B3:C3").format.wrapText = true;
                                    sheet.getRange("B3:C3").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B3:C3").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("B4").values = [[eupType.name]];
                                    sheet.getRange("B4:C4").merge();
                                    sheet.getRange("B4:C4").format.wrapText = true;
                                    sheet.getRange("B4:C4").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B4:C4").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("B5:C5").numberFormat = [["@"]]; // Format tekstowy ustawiony PRZED wstawieniem wartości
                                    sheet.getRange("B5").values = [[eupType.identificationNumber]];
                                    sheet.getRange("B5:C5").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B5:C5").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("B6").values = [["".concat(dateFrom.toLocaleDateString(), " - ").concat(dateTo.toLocaleDateString())]];
                                    sheet.getRange("B6:C6").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B6:C6").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    currentdate = new Date();
                                    formattedDate = currentdate.toLocaleDateString("pl-PL", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit"
                                    });
                                    sheet.getRange("B7").values = [[formattedDate]];
                                    sheet.getRange("B7").format.horizontalAlignment = "Left";
                                    sheet.getRange("B7:C7").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("B7:C7").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    // Aktywuj arkusz
                                    sheet.activate();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Metoda dodaje nagłówki kolumn dla danych z Matrix
 * @param sheetName - arkusz do wstawienia nagłówka
 */
function addMatrixHeaders(sheetName) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, headerTitleRange, columns;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    sheet.getRange("9:9").format.rowHeight = common_1.matrixHeadersDefaultRowHeight;
                                    headerTitleRange = sheet.getRange("A9:P9");
                                    headerTitleRange.format.fill.color = "#404040";
                                    headerTitleRange.format.font.bold = true;
                                    headerTitleRange.format.font.color = "#FFFFFF";
                                    headerTitleRange.format.font.size = common_1.matrixHeadersDefaultFontSize;
                                    headerTitleRange.format.verticalAlignment = "Center";
                                    headerTitleRange.format.horizontalAlignment = "Center";
                                    headerTitleRange.format.wrapText = true;
                                    headerTitleRange.values = [headers];
                                    columns = ["A9", , "B9", "C9", "D9", "E9", "F9", "G9", "H9", "I9", "J9", "K9", "L9", "M9", "N9", "O9", "P9"];
                                    columns.forEach(function (cellAddress) {
                                        sheet.getRange(cellAddress).format.borders.getItem("EdgeLeft").color = "#E8E8E8";
                                        sheet.getRange(cellAddress).format.borders.getItem("EdgeLeft").weight = Excel.BorderWeight.thin;
                                    });
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Metoda wstawia informacj o braku danych do raportu dla zadanego okresu i dla wybranego MPD
 * @param sheetName - nazwa arkusza
 * @param eupType - dane wybranego EUP
 */
function insertNoDataMessage(sheetName, eupType) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, noDataMessageRange, columns, rows;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    noDataMessageRange = sheet.getRange("A10:P12");
                                    noDataMessageRange.format.rowHeight = 30;
                                    noDataMessageRange.format.fill.color = "#F6F6F6";
                                    noDataMessageRange.format.font.size = 12;
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    columns = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P"];
                                    rows = [10, 11, 12];
                                    rows.forEach(function (row) {
                                        columns.forEach(function (col) {
                                            var cellAddress = "".concat(col).concat(row);
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                        });
                                    });
                                    sheet.getRange("A11").values = [["Brak danych do raportu dla zadanego okresu i dla wybranego MPD"]];
                                    sheet.getRange("A11").format.font.color = "#F10606";
                                    sheet.getRange("A11").format.font.size = 14;
                                    //sheet.getRange("A11").format.horizontalAlignment = "Center";
                                    sheet.getRange("A11").format.verticalAlignment = "Center";
                                    return [4 /*yield*/, context.sync()];
                                case 2:
                                    _a.sent();
                                    // Dodanie Trial w wierszu po ostatnim wpise z matrix + 2 od wpisanych
                                    return [4 /*yield*/, (0, common_1.insertTrialNoticeRow)(sheet, "A14:P14", eupType.isTrial)];
                                case 3:
                                    // Dodanie Trial w wierszu po ostatnim wpise z matrix + 2 od wpisanych
                                    _a.sent();
                                    // Dodanie Copyright 
                                    return [4 /*yield*/, (0, common_1.insertCopyrightRow)(sheet, "A15:P15")];
                                case 4:
                                    // Dodanie Copyright 
                                    _a.sent();
                                    // Aktywuj arkusz
                                    sheet.getRange("A1").select();
                                    sheet.activate();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Metoda dodaje dane z MAtrix do arkusza
 * @param sheetName - nazwa arkusza
 * @param matrix - macierz danych do wstawienia
 * @param eupType - dane wybranego EUP
 */
function insertMatrixData(sheetName, matrix, eupType) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, dataMatrix, rowRange, range, dataRowsCount, _loop_1, i, textFormatColumns, trialRow, copyrightRow;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    dataMatrix = matrix.slice(1);
                                    rowRange = 9 + dataMatrix.length;
                                    range = sheet.getRange("A10:P" + rowRange);
                                    range.values = dataMatrix;
                                    dataRowsCount = dataMatrix.length;
                                    _loop_1 = function (i) {
                                        var rowIndex = i + 10; // 10 to początkowy wiersz danych
                                        var rowRange_1 = sheet.getRange("A".concat(rowIndex, ":P").concat(rowIndex));
                                        // Wysokość wiersza
                                        rowRange_1.format.rowHeight = 30;
                                        // Kolor tła #F7F7F7
                                        rowRange_1.format.fill.color = "#F7F7F7";
                                        // Kolor czcionki #000000
                                        rowRange_1.format.font.color = "#000000";
                                        // Rozmiar czcionki 12
                                        rowRange_1.format.font.size = 12;
                                        // Wyrównanie tekstu do lewej
                                        rowRange_1.format.horizontalAlignment = "Left";
                                        // Wyrównanie pionowe do środka
                                        rowRange_1.format.verticalAlignment = "Center";
                                        // Dodanie border dół i prawo w kolorze #E9E9E9
                                        rowRange_1.format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                        rowRange_1.format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                        // Dodanie prawego obramowania dla każdej komórki w wierszu
                                        var columns = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P"];
                                        columns.forEach(function (col) {
                                            var cellRange = sheet.getRange("".concat(col).concat(rowIndex));
                                            cellRange.format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                            cellRange.format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                        });
                                    };
                                    for (i = 0; i < dataRowsCount; i++) {
                                        _loop_1(i);
                                    }
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    //Kolumna A dla wartości matrix jest wyrównana do środka
                                    sheet.getRange("A10:A" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    //Kolumna B dla wartości matrix jest wyrównana do środka i wartości zapisane jako tekst
                                    sheet.getRange("B10:B" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    textFormatColumns = ["B"];
                                    textFormatColumns.forEach(function (column) {
                                        var columnRange = sheet.getRange("".concat(column, "10:").concat(column) + (9 + dataMatrix.length));
                                        // Stwórz tablicę formatów dla wszystkich komórek w kolumnie
                                        var formatArray = Array(dataMatrix.length).fill(["@"]);
                                        columnRange.numberFormat = formatArray;
                                    });
                                    // Kolumna C wartości Matrix jest wyrównana do lewej i ma zawijanie tekstu
                                    sheet.getRange("C10:C" + (9 + dataMatrix.length)).format.horizontalAlignment = "Left";
                                    sheet.getRange("C10:C" + (9 + dataMatrix.length)).format.wrapText = true;
                                    // Kolumna D wartości Matrix jest wyrównana do środka
                                    sheet.getRange("D10:D" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    // Kolumna E wartości Matrix jest wyrównana do środka w formacie numerycznym z dokładnością do 4 miejsca po przecinku i tak prezentowana
                                    sheet.getRange("E10:E" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    sheet.getRange("E10:E" + (9 + dataMatrix.length)).numberFormat = [["0.0000"]]; // Ustawienie formatu numerycznego z dokładnością do 4 miejsc po przecinku
                                    // Kolumna F wartości Matrix jest wyrównana do środka
                                    sheet.getRange("F10:F" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    // Kolumna F ma kolor tła zależnie od wartości wpisanej w Value
                                    // Potwierdzenie transportu - #E8F7E4
                                    // Potwierdzenie przejęcia - #E5EEF9
                                    // Planowana - #F7F7D8
                                    // Zatwierdzone - #B5E6A2
                                    // Potwierdzenie wygenerowane - #F0E1C2 
                                    // Wycofana - #FBE5EA
                                    // Odrzucona - #FF8E6F
                                    dataMatrix.forEach(function (row, index) {
                                        var status = row[5]; // Zakładam, że status jest w kolumnie F (indeks 5)
                                        var color = "#F7F7F7"; // Domyślny kolor
                                        switch (status) {
                                            case "Potwierdzenie transportu":
                                                color = "#B5E6A1";
                                                break;
                                            case "Potwierdzenie przejęcia":
                                                color = "#E5EEF9";
                                                break;
                                            case "Planowana":
                                                color = "#F7F7D8";
                                                break;
                                            case "Zatwierdzona":
                                                color = "#DDF8DB";
                                                break;
                                            case "Potwierdzenie wygenerowane":
                                                color = "#F0E0C2";
                                                break;
                                            case "Wycofana":
                                                color = "#FBE5EA";
                                                break;
                                            case "Odrzucona":
                                                color = "#FF8F6F";
                                                break;
                                        }
                                        sheet.getRange("F".concat(10 + index)).format.fill.color = color; // Ustawienie koloru tła dla kolumny G
                                    });
                                    // Kolumna G wartości Matrix jest wyrównana do środka i ma format daty lokalnej
                                    sheet.getRange("G10:G" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    sheet.getRange("G10:G" + (9 + dataMatrix.length)).numberFormat = [["dd.mm.yyyy"]]; // Ustawienie formatu daty lokalnej
                                    // Kolumna H wartości Matrix jest wyrównana do środka i ma format daty lokalnej
                                    sheet.getRange("H10:H" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    sheet.getRange("H10:H" + (9 + dataMatrix.length)).numberFormat = [["dd.mm.yyyy"]]; // Ustawienie formatu daty lokalnej
                                    // Kolumna I wartości Matrix jest wyrównana do środka
                                    sheet.getRange("I10:I" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    // Kolumna L wartości Matrix jest wyrównana do środka i ma format daty lokalnej
                                    sheet.getRange("L10:L" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    sheet.getRange("L10:L" + (9 + dataMatrix.length)).numberFormat = [["dd.mm.yyyy"]]; // Ustawienie formatu daty lokalnej
                                    // Kolumna O wartości Matrix jest wyrównana do środka
                                    sheet.getRange("O10:O" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    // Warunek: jezeli w kolumnie O dla wstawianej komórki jest wartość "brak karty KEO" wówczas ustaw kolor czcionki na RED dal kazdej innej wartosci kolor standardowy
                                    dataMatrix.forEach(function (row, index) {
                                        var keoCardNumber = row[14]; // Kolumna O (indeks 14) - "Uwzględnione w Karcie Ewidencji Odpadów (KEO)"
                                        var cellRange = sheet.getRange("O".concat(10 + index));
                                        if (keoCardNumber === "brak karty KEO") {
                                            cellRange.format.font.color = "#FF0000"; // Czerwony kolor dla "brak karty KEO"
                                        }
                                        else {
                                            cellRange.format.font.color = "#000000"; // Standardowy czarny kolor dla innych wartości
                                        }
                                    });
                                    // Kolumna P wartości Matrix jest wyrównana do środka
                                    sheet.getRange("P10:P" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    return [4 /*yield*/, context.sync()];
                                case 2:
                                    _a.sent();
                                    // Dodanie filtrowania do nagłówków dla całego dodanego zakresu Matrix
                                    sheet.autoFilter.apply(sheet.getRange("A9:P" + (9 + dataMatrix.length)));
                                    //Dodanie freez dla kolumn
                                    //sheet.freezePanes.freezeAt(sheet.getRange("A:C"));
                                    // Synchronizacja przed select
                                    return [4 /*yield*/, context.sync()];
                                case 3:
                                    //Dodanie freez dla kolumn
                                    //sheet.freezePanes.freezeAt(sheet.getRange("A:C"));
                                    // Synchronizacja przed select
                                    _a.sent();
                                    trialRow = rowRange + 2;
                                    return [4 /*yield*/, (0, common_1.insertTrialNoticeRow)(sheet, "A".concat(trialRow, ":P").concat(trialRow), eupType.isTrial)];
                                case 4:
                                    _a.sent();
                                    copyrightRow = rowRange + 3;
                                    return [4 /*yield*/, (0, common_1.insertCopyrightRow)(sheet, "A".concat(copyrightRow, ":P").concat(copyrightRow))];
                                case 5:
                                    _a.sent();
                                    // Aktywuj arkusz
                                    sheet.getRange("A1").select();
                                    sheet.activate();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=kpo_confirmed.js.map